import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IApplicationInspectionFile, IApplicationInspectionFileInput } from '@ebb-v2/ebb-integration';

@Injectable({
  providedIn: 'root'
})
export abstract class ApplicationInspectionFileApiService {

  abstract list(applicationId: string): Observable<IApplicationInspectionFile[]>;

  abstract update(applicationInspectionFileInput: IApplicationInspectionFileInput, applicationInspectionFileId: string | ''): Observable<IApplicationInspectionFile>;
}